import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Breadcrumb, Button,
  Card,
  Col,
  Collapse,
  Divider,
  Row,
  Typography,
} from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ImageWithAuth from "../../../../Components/ImageAuth";
import { ArrowLeftOutlined } from "@ant-design/icons";

const { Title } = Typography;
const { Panel } = Collapse;

const CreateAgendaDetail = () => {
  const { key } = useParams();
  const { t } = useTranslation();
  const [scData, setScData] = useState<Record<string, any>>({});
  const navigate = useNavigate();

  useEffect(() => {
    const stored = sessionStorage.getItem("scDetail");
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        setScData(parsed);
      } catch (e) {
        console.error("Error parsing sessionStorage data:", e);
      }
    }
  }, []);

  const isQuestionKey = (key: string) => key.startsWith("q_");

  const goToBack = () => {
    const urlNavigation = (scData?.cinScNumber) ? '/scuapp/create_agenda' : '/scuapp/create_agenda_new_stories';
    sessionStorage.removeItem("scDetail");
    navigate(urlNavigation);
  }

  return (
      <Row justify="center">
        <Col span={24} className="p-1">
          <Row gutter={[20, 20]}>
            <Col span={24}>
              <Breadcrumb>
                <Breadcrumb.Item>SCUAPP</Breadcrumb.Item>
                <Breadcrumb.Item>{key}</Breadcrumb.Item>
              </Breadcrumb>
              <Title level={3}>{t("scuSciDetail")}</Title>
            </Col>

            <Col span={24}>
              <Row>
                <Col span={24} className="text-right mb-1">
                  <Button size="large" type="dashed" danger className="btn-border-radius" onClick={() => goToBack()}>
                    <ArrowLeftOutlined />{t('return')}
                  </Button>
                </Col>
              </Row>
              <Card className="border-radius">
                <Row gutter={[16, 16]}>
                  {/* Información general del niño */}
                  <Col span={24}>
                    <Title level={4}>{t("childInformation")}</Title>
                    <Row gutter={[16, 8]}>
                      {
                          (scData?.cinScNumber) && (
                              <Col span={12}><strong>{t("scNumber")}:</strong> {scData?.cinScNumber}</Col>
                          )
                      }
                      <Col span={12}><strong>{t("fullName")}:</strong> {scData?.cinScName}</Col>
                      <Col span={12}><strong>{t("knownAs")}:</strong> {scData?.cinScKnowBy}</Col>
                      <Col span={12}><strong>{t("gender")}:</strong> {t(scData?.cinScGenre || '')}</Col>
                      <Col span={12}><strong>{t("bornDate")}:</strong> {scData?.cinScBornDate}</Col>
                      <Col span={12}><strong>{t("age")}:</strong> {scData?.age}</Col>
                      <Col span={12}><strong>{t("community")}:</strong> {scData?.cinNombreComunidad}</Col>
                      <Col span={12}><strong>{t("communityCode")}:</strong> {scData?.cinCodigoComunidad}</Col>
                      {
                          (scData?.cinOrganizacionNacional) && (
                              <Col span={12}><strong>{t("organization")}:</strong> {scData?.cinOrganizacionNacional}</Col>
                          )
                      }
                      <Col span={12}><strong>{t("fiscalYear")}:</strong> {scData?.cinFiscalYear}</Col>
                      <Col span={12}><strong>{t("interviewedBy")}:</strong> {scData?.cinPersonaEntrevistada}</Col>
                      <Col span={12}><strong>{t("interviewDate")}:</strong> {scData?.cinFechaEntrevista}</Col>
                    </Row>
                  </Col>


                  {/* Fotos tomadas */}
                  <Col span={24}>
                    <Divider />
                    <Row justify="space-between">
                      <Col>
                        <Title level={4}>{t("childInformationFiles")}</Title>
                      </Col>
                    </Row>
                    <Row className='mt-1' gutter={[30,30]}>
                      <Col span={24} md={12}>
                        <Title level={4}>{t('scPhotoActualSc')}</Title>
                        <ImageWithAuth src={scData?.cin_sc_child_actual_photo || ''} scId={scData?.cinId} folder='comms' />
                      </Col>
                      <Col span={24} md={12}>
                        <Title level={4}>{t('scPhotoActualFamily')}</Title>
                        <ImageWithAuth src={scData?.cin_sc_family_actual_photo || ''} scId={scData?.cinId} viewMetadata={true} folder='comms' />
                      </Col>
                      <Col span={24} md={12}>
                        <Title level={4}>{t('scConsentFormPhotoActual')}</Title>
                        <ImageWithAuth src={scData?.cin_sc_consent_actual_photo || ''} scId={scData?.cinId} folder='comms' />
                      </Col>
                    </Row>
                  </Col>

                  {/* Preguntas y respuestas */}
                  <Col span={24}>
                    <Divider />
                    <Title level={4}>{t("questionsAndAnswers")}</Title>
                    <Collapse defaultActiveKey={["1"]}>
                      <Panel header={t("answersPanel")} key="1">
                        <Row gutter={[16, 12]}>
                          {Object.entries(scData)
                              .filter(([key]) => isQuestionKey(key))
                              .map(([key, value]) => (
                                  <Col span={12} key={key}>
                                    <strong>{t(key)}:</strong> {value || t("noAnswer")}
                                  </Col>
                              ))}
                        </Row>
                      </Panel>
                    </Collapse>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
  );
};

export default CreateAgendaDetail;
